'use client';

import { FC } from 'react';
import DiscountPrice from './discount-price';
import { Conditional } from '@cat-ecom/pcc-components';
import { useTranslations } from 'next-intl';
import cx from 'classnames';
import {
  checkIsRiyal,
  getRiyalFormattedPrice
} from 'app/[lang]/[esite]/utils/paymentUtils';
import { PriceAvailabilityResponseHeadless } from 'services/priceAvailability/types';

interface PriceProps {
  price: PriceAvailabilityResponseHeadless['items'][0];
  currency: string;
  showDiscountSection?: boolean;
  isCoreDepositMobileDrawer?: boolean;
  isMobileView?: boolean;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
  isLeftAlignPriceTag?: boolean;
}

const Price: FC<PriceProps> = ({
  price,
  currency,
  showDiscountSection = true,
  isCoreDepositMobileDrawer = false,
  isMobileView = false,
  isRTL = false,
  currencyLdFeatureFlag = false,
  isLeftAlignPriceTag = false
}) => {
  const t = useTranslations();
  const saudiCurrencySymbol = currencyLdFeatureFlag && checkIsRiyal(currency);
  const showPrice = (price) => {
    return saudiCurrencySymbol ? (
      <p>
        {getRiyalFormattedPrice({
          price: `${price} ${t('ITEM_EA_ABB')}`,
          priceWrapperClasses: cx('px-1', {
            'cat-u-theme-typography-body-sm': !isMobileView,
            'mb-0 cat-u-theme-typography-footnote': isMobileView
          }),
          isRTL: isRTL,
          size: 'xxs'
        })}
      </p>
    ) : (
      <p
        className={cx({
          'cat-u-theme-typography-body-sm': !isMobileView,
          'mb-0 cat-u-theme-typography-footnote': isMobileView
        })}
        style={{ color: 'var(--cat-color-neutral-60)' }}
      >
        {`${price}   ${t('ITEM_EA_ABB')}`}
      </p>
    );
  };
  return (
    !!price?.price?.formatted?.totalPrice && (
      <>
        {price.partLevelFlags.isAddToCartEnabled && (
          <p
            className={cx('m-0', {
              'ps-2': !isMobileView && !isLeftAlignPriceTag,
              'pt-1': isMobileView && !isLeftAlignPriceTag
            })}
          >
            {saudiCurrencySymbol ? (
              getRiyalFormattedPrice({
                price: price?.price?.formatted?.totalPrice,
                priceWrapperClasses: 'cat-u-theme-typography-title-sm px-1',
                isRTL: isRTL,
                size: 'sm'
              })
            ) : (
              <>
                <span className="cat-u-theme-typography-title-sm">
                  {`${price?.price?.formatted?.totalPrice} `}
                </span>
                <span
                  className={cx('px-1', {
                    'cat-u-theme-typography-label-lg': !isMobileView,
                    'fw-normal': isMobileView
                  })}
                >
                  {currency}
                </span>
              </>
            )}
          </p>
        )}

        <Conditional
          test={
            price?.price?.formatted.unitPrice !==
              price?.price?.formatted.totalPrice && price.quantity > 1
          }
        >
          {price?.price?.formatted?.discountedPrice
            ? showPrice(price?.price?.formatted?.discountedPrice)
            : showPrice(price?.price?.formatted?.unitPrice)}
        </Conditional>
        <Conditional test={showDiscountSection}>
          <DiscountPrice
            price={price}
            isCoreDepositMobileDrawer={isCoreDepositMobileDrawer}
            isMobile
            currency={currency}
            isRTL={isRTL}
            currencyLdFeatureFlag={currencyLdFeatureFlag}
            isProductOverview={false}
          />
        </Conditional>
      </>
    )
  );
};

export default Price;
